<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          <h1 style="float: left">Roles</h1>

          <CButton
            color="primary"
            class="px-4"
            style="float: right"
            @click="crear()"
            ><CIcon name="cil-user" /> Nuevo</CButton
          >
          <filters
            :campos="filterFields"
            :itemsKeys="{
              text: 'value',
              value: 'id',
            }"
            :eventName="'fetchItemsEvent'"
          ></filters>
        </CCardHeader>
        <CCardBody>
          <div class="text-center" v-if="loading">
            <div class="spinner-border" role="status"></div>
          </div>
          <CDataTable
            v-if="!loading"
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="50"
            :active-page="activePage"
            :pagination="{ doubleArrows: false, align: 'center' }"
            @page-change="pageChange"
          >
            <template #activo="data">
              <td>
                <CBadge :color="data.item.activo ? 'success' : 'secondary'">
                  {{ data.item.activo == 1 ? "Habilitado" : "Inhabilitado" }}
                </CBadge>
              </td>
            </template>
            <template #acciones="data">
              <td>
                <CLink
                  href="#"
                  @click="editar(data.item)"
                  class="card-header-action btn-setting"
                  v-c-tooltip.hover.click="'Editar'"
                >
                  <CIcon name="cil-pencil" />
                </CLink>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Filters from "@/components/filters";
import RoleService from "@/services/role.service";
import { mapState } from "vuex";
import EventBus from "@/common/EventBus";

export default {
  name: "Roles",
  data() {
    return {
      items: [],
      fields: [
        { key: "name", label: "Nombre", _classes: "font-weight-bold" },
        { key: "acciones" },
      ],
      filterFields: [
        { value: "name", label: "Nombre" },
        //TODO carga de permiso desde base de datos
        /*{
          value: "permission_id",
          label: "Permiso",
          options: [
            { id: 101, value: "Gestión de Usuarios" },
            { id: 102, value: "Gestión de Roles" },
            { id: 201, value: "Definición de layouts" },
            { id: 301, value: "Definición de variables" },
            { id: 302, value: "Definición de reglas de calidad" },
            { id: 303, value: "Definición de proceso de calidad" },
            { id: 304, value: "Ejecución de proceso de calidad" },
            { id: 305, value: "Consultar log de ejecuciones" },
            { id: 401, value: "COMDAC" },
            { id: 402, value: "Desincorporación" },
          ],
        },*/
      ],
      activePage: 1,
      loading: false,
      message: "",
    };
  },
  components: {
    Filters,
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {
    if (!this.permissions.includes("Gestión de Roles"))
      this.$router.push("/dashboard");
    this.fetchItems("");
    EventBus.on("fetchItemsEvent", (cadenaBusqueda) => {
      this.fetchItems(cadenaBusqueda);
    });
  },
  methods: {
    fetchItems(cadenaBusqueda) {
      this.loading = true;
      RoleService.getItems(cadenaBusqueda).then(
        (response) => {
          this.items = response.data;
          console.log(response.data);
          this.loading = false;
        },
        (error) => {
          this.content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.loading = false;
        }
      );
    },
    crear() {
      localStorage.removeItem("datos_rol");
      this.$router.push({ path: `roles/editar/` });
    },
    editar(item) {
      localStorage.setItem("datos_rol", JSON.stringify(item));
      this.$router.push({ path: `roles/editar/` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
  },
};
</script>
